import { authApi } from '../api/generated/auth.api.js';
import { apiClient, STEP_UP_ERROR_CODES } from '../api/ApiClient.js';
import type { StepUpAuthRequest } from '@cnapse/shared/schemas.js';

export type StepUpAuthResult = {
  stepUpToken: string;
  expiresIn: number;
  mfaRequired: boolean;
};

export type StepUpAuthError = Error & {
  errorCode?: string;
  mfaRequired?: boolean;
  httpStatus?: number;
};

export function isStepUpMfaRequired(error: unknown): boolean {
  if (!error || typeof error !== 'object') return false;
  const err = error as StepUpAuthError;
  return (
    err.mfaRequired === true ||
    err.errorCode === STEP_UP_ERROR_CODES.MFA_REQUIRED
  );
}

class StepUpAuthService {
  async verifyStepUp(credentials: StepUpAuthRequest): Promise<StepUpAuthResult> {
    return (await authApi.stepUp(credentials)) as StepUpAuthResult;
  }

  async runWithStepUp<T>(
    credentials: StepUpAuthRequest,
    action: (stepUpToken: string) => Promise<T>,
  ): Promise<T> {
    const { stepUpToken } = await this.verifyStepUp(credentials);
    return apiClient.withStepUpToken(stepUpToken, () => action(stepUpToken));
  }
}

export const stepUpAuthService = new StepUpAuthService();
